import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import BlogEntryCard from '@/views/blog/components/BlogEntry.vue';
import PublicBlogPage from './PublicBlogPage.vue';
// TODO: Replace with real public API call once the endpoint exists
import { localPublicBlogEntries } from './localBlogData';


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicBlog',
  setup(__props) {

const articles = computed(() => [...localPublicBlogEntries]
  .sort((articleA, articleB) => articleA.position - articleB.position));

return { __sfc: true,articles, BlogEntryCard, PublicBlogPage }
}

})